import SubLayout from "@/components/SubLayout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";

export const PageMessageDetail = () => {
  const navigate = useNavigate();
  const [text] = useState<string>(() => {
    return localStorage.getItem("MSG_CONTENT") || "";
  });

  const onBack = () => {
    localStorage.removeItem("MSG_CONTENT");
    navigate(-1);
  };

  return (
    <SubLayout
      title={"消息详情"}
      header={{
        onBack,
      }}
    >
      <section className={styles.content} dangerouslySetInnerHTML={{__html:text || ''}}></section>
    </SubLayout>
  );
};
